import { Link } from "react-router-dom";
import { RFQForm } from "../components/site/RFQForm";
import { Seo, breadcrumbSchema } from "../components/site/Seo";
import { PHONE_DISPLAY, PHONE_HREF, EMAIL } from "../components/site/ContactActions";
import { track } from "../lib/track";

export default function RequestQuote() {
  return (
    <div data-testid="request-quote-page">
      <Seo route="/request-a-quote" jsonLd={breadcrumbSchema([{ name: "Home", path: "/" }, { name: "Request a Quote", path: "/request-a-quote" }])} />
      <section className="pt-[130px] pb-14 hero-bg">
        <div className="pg-container max-w-4xl">
          <span className="eyebrow" style={{ color: "#7EC4FF" }}>Submit an RFQ</span>
          <h1 className="mt-5 text-[38px] md:text-[52px] font-extrabold leading-[1.06] text-white">Request a Procurement Quote</h1>
          <p className="mt-5 text-[17px] text-white/80 max-w-2xl leading-relaxed">
            Have an RFQ? Need a specific product? Looking for a supplier? Need equipment delivered?
            Send us the details — a Patrick Global representative will review your requirement and contact you.
          </p>
          <p className="mt-4 text-[14.5px] text-white/70" data-testid="rfq-alt-contact">
            Prefer a quick message? <Link to="/contact" data-testid="rfq-short-inquiry-link" className="text-[#7EC4FF] font-semibold hover:text-white">Use the short inquiry form</Link>,
            call <a href={PHONE_HREF} className="text-[#7EC4FF] font-semibold hover:text-white" onClick={() => track("phone_click", { source: "rfq_page" })}>{PHONE_DISPLAY}</a>,
            or email <a href={`mailto:${EMAIL}`} className="text-[#7EC4FF] font-semibold hover:text-white" onClick={() => track("email_click", { source: "rfq_page" })}>{EMAIL}</a>.
          </p>
        </div>
      </section>
      <section className="py-14 md:py-20 bg-[var(--pg-bg)]">
        <div className="pg-container max-w-4xl">
          <RFQForm />
        </div>
      </section>
    </div>
  );
}
